<div class="big-card-page" data-test="reset-password">
  <div class="big-card-page__card">
    <div class="big-card-page__icon">
      <img [src]="'/assets/images/icons/' + iconFileName + '.svg'" alt="" />
    </div>
    <div
      class="big-card-page__title"
      [innerHTML]="'RESET_PASSWORD.' + contentTranslateKey + '.TITLE' | translate"
      data-test="reset-password-title"
    ></div>
    <div
      class="big-card-page__desc"
      [innerHTML]="'RESET_PASSWORD.' + contentTranslateKey + '.DESCRIPTION' | translate"
      data-test="reset-password-description"
    ></div>
    <div class="big-card-page__form">
      <form [formGroup]="formGroup" *ngIf="!formSent" (submit)="submit()">
        <div class="rm-field">
          <input
            [formControlName]="formControls.NewPassword"
            [placeholder]="'RESET_PASSWORD.FORM.NEW_PASSWORD.LABEL' | translate"
            type="password"
            name="new-passsword"
            class="rm-input rm-input--with-errors rm-input--center"
            data-test="reset-password-new-password-input"
          />
          <div class="rm-field__hint" *ngIf="passwordLengthError">
            {{ 'RESET_PASSWORD.FORM.NEW_PASSWORD.PASSWORD_LENGTH_ERROR' |
            translate: { minimumLength: minimumLength} }}
          </div>
        </div>
        <div class="rm-field">
          <input
            [formControlName]="formControls.NewPasswordConfirm"
            [placeholder]="'RESET_PASSWORD.FORM.NEW_PASSWORD_CONFIRM.LABEL' | translate"
            type="password"
            name="new-password-confirm"
            class="rm-input rm-input--with-errors rm-input--center"
            data-test="reset-password-new-password-input-confirmation"
          />
          <div class="rm-field__hint" *ngIf="passwordAreNotTheSame">
            {{
            'RESET_PASSWORD.FORM.NEW_PASSWORD_CONFIRM.PASSWORD_ARE_NOT_THE_SAME'
            | translate }}
          </div>
        </div>
        <button
          [disabled]="(submitted && !formGroup.valid) || submitting"
          class="rm-button rm-button--full-width rm-button--primary"
          data-test="reset-password-submit"
        >
          {{ 'RESET_PASSWORD.FORM.SUBMIT' | translate }}
        </button>
      </form>
      <div *ngIf="formSent">
        <a
          [routerLink]="['/login']"
          [queryParams]="queryParams"
          class="rm-button rm-button--full-width rm-button--primary"
          data-test="reset-password-back-to-connection"
        >
          {{ 'RESET_PASSWORD.LOGIN' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
